// ============ TIMER ============ 
  // document.addEventListener("DOMContentLoaded", function() {
  //   // Set countdown duration (in seconds) — e.g. 1 day
  //   const countdownDuration = 24 * 60 * 60; // 1 day in seconds

  //   let timeLeft = countdownDuration;

  //   function updateTimer() {
  //     const days = Math.floor(timeLeft / (24 * 60 * 60));
  //     const hours = Math.floor((timeLeft % (24 * 60 * 60)) / 3600);
  //     const minutes = Math.floor((timeLeft % 3600) / 60);
  //     const seconds = Math.floor(timeLeft % 60);

  //     document.getElementById("days").textContent = String(days).padStart(2, "0");
  //     document.getElementById("hours").textContent = String(hours).padStart(2, "0");
  //     document.getElementById("minutes").textContent = String(minutes).padStart(2, "0");
  //     document.getElementById("seconds").textContent = String(seconds).padStart(2, "0");

  //     if (timeLeft <= 0) {
  //       timeLeft = countdownDuration; // Reset timer when it ends
  //     } else {
  //       timeLeft--;
  //     }
  //   }

  //   // Initialize and update every second
  //   updateTimer();
  //   setInterval(updateTimer, 1000);
  // });


// ============ REVIEWS SECTION ============

var reviewsSwiper = new Swiper('.reviews-swiper', {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  autoplay: {
    delay: 5000000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.reviews-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: '.reviews-button-next',
    prevEl: '.reviews-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
});

// ============ PRODUCT GALLERY ============

document.addEventListener('DOMContentLoaded', function () {
  var gallerySwiper = new Swiper('.gallerySwiper', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    loop: true,
    navigation: {
      nextEl: '.gallery-button-next',
      prevEl: '.gallery-button-prev',
    },
    breakpoints: {
      576: { slidesPerView: 2.2 },
      768: { slidesPerView: 3 },
      1024: { slidesPerView: 4 },
    },
  });
});

// var toggleBtn = document.querySelector('.toggle-btn');

// if (toggleBtn) {
//   toggleBtn.addEventListener('click', function () {
//     var buttonContainer = document.querySelector('.additional_checkout_buttons');

//     if (buttonContainer) {
//       buttonContainer.classList.toggle('show');
//     }
//   });
// }

// TABLE OF CONTENT

document.addEventListener("DOMContentLoaded", function() {
  const articleContent = document.querySelector('.article-template__content');
  const tocList = document.getElementById('toc-list');
  const tocWrapper = document.getElementById('toc-wrapper');
  if (!articleContent || !tocList) return;

  // First, look for heading tags (h2, h3, h4)
  let headings = articleContent.querySelectorAll('h2, h3, h4');

  // If no headings found, fall back to bold tags (b or strong)
  if (headings.length === 0) {
    headings = articleContent.querySelectorAll('b, strong');
  }

  // If still nothing found, hide TOC completely
  if (headings.length === 0) {
    tocWrapper.style.display = 'none';
    return;
  }

  // ✅ Build Table of Contents dynamically
  headings.forEach((heading, index) => {
    const id = 'section-' + index;
    heading.setAttribute('id', id);

    const li = document.createElement('li');
    const tag = heading.tagName.toLowerCase();

    // Assign classes for indentation levels
    if (tag === 'h2') li.className = 'toc-item';
    if (tag === 'h3') li.className = 'toc-subitem';
    if (tag === 'h4') li.className = 'toc-subsubitem';
    if (tag === 'b' || tag === 'strong') li.className = 'toc-fallback-item';

    const a = document.createElement('a');
    a.href = '#' + id;
    a.textContent = heading.textContent.trim();
    a.addEventListener('click', (e) => {
      e.preventDefault();
      document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    li.appendChild(a);
    tocList.appendChild(li);
  });
});



// SCROLL CLASS TABLE OF CONTENT
document.addEventListener('DOMContentLoaded', function () {
  var toggleElement = document.querySelector('.custOverviewTgl');
  // ✅ Set default active state on page load
  document.body.classList.add('active');
  if (toggleElement) {
    toggleElement.addEventListener('click', function () {
      document.body.classList.toggle('active');
    });
  }
});



// MEGA MENU ITEM

(function(){
  if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;
  document.querySelectorAll('.header__inline-menu details').forEach(function(d){
    d.addEventListener('mouseenter', ()=> d.open = true);
    d.addEventListener('mouseleave', ()=> d.open = false);
    d.addEventListener('focusin', ()=> d.open = true);
    d.addEventListener('focusout', (e)=> { if (!d.contains(e.relatedTarget)) d.open = false; });
  });
})();


function wrapRegisteredSymbol(node) {

  if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SCRIPT' && node.getAttribute('type') === 'application/ld+json') {
    return;
  }

    if (node.nodeType === Node.TEXT_NODE) {
        const text = node.nodeValue;
        if (text.includes("®")) {
            const parts = text.split("®");
            const fragment = document.createDocumentFragment();

            parts.forEach((part, index) => {
                fragment.appendChild(document.createTextNode(part));
                if (index < parts.length - 1) {
                    const sup = document.createElement("sup");
                    sup.className = "custPreR";
                    sup.textContent = "®";
                    fragment.appendChild(sup);
                }
            });

            node.replaceWith(fragment);
        }
    } else {
        node.childNodes.forEach(wrapRegisteredSymbol);
    }
}

wrapRegisteredSymbol(document.body);

/*
window.onload = function () {
  setTimeout(function () {
    if (window.innerWidth < 769) {
      const gbb_bundle_footer = document.querySelector('.gbbAddProductsPageFooterHTML');
      const gbb_cat_container = document.querySelector('.gbbMultipleCategoryHeaderContainer');
      const gbb_BoxSelectionWrapper = document.querySelector('.gbbBoxSelectionWrapper');

      if (gbb_bundle_footer && gbb_cat_container) {
        gbb_cat_container.after(gbb_bundle_footer);
        //gbb_cat_container.parentNode.insertBefore(gbb_bundle_footer, gbb_cat_container.nextSibling);
      }

      // if (gbb_BoxSelectionWrapper && gbb_cat_container) {
      //   gbb_cat_container.after(gbb_BoxSelectionWrapper);
      //   //gbb_cat_container.parentNode.insertBefore(gbb_bundle_footer, gbb_cat_container.nextSibling);
      // }
    }
  },800);
} */

document.addEventListener("DOMContentLoaded", function () {

  function initSlider() {

    if (window.innerWidth > 767) return;

    document.querySelectorAll(".trust-badge-bar__inner.mobile-slider").forEach((slider) => {

      if (slider.dataset.sliderInit === "true") return;
      slider.dataset.sliderInit = "true";

      const items = slider.querySelectorAll(".trust-badge-bar__item");
      let index = 0;

      function animateScroll(target, duration = 700) {
        const start = slider.scrollLeft;
        const change = target - start;
        const startTime = performance.now();

        function easeInOut(t) {
          return t < 0.5
            ? 2 * t * t
            : 1 - Math.pow(-2 * t + 2, 2) / 2;
        }

        function animate(currentTime) {
          const elapsed = currentTime - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeInOut(progress);

          slider.scrollLeft = start + change * eased;

          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        }

        requestAnimationFrame(animate);
      }

      function move() {
        const item = items[index];
        if (!item) return;

        animateScroll(item.offsetLeft, 800); // slower + smoother

        // fade effect
        items.forEach(el => el.classList.remove("active"));
        item.classList.add("active");
      }

      function next() {
        index = (index + 1) % items.length;
        move();
      }

      move();

      const intervalId = setInterval(next, 4000); // more breathing space
      slider.dataset.intervalId = intervalId;
    });
  }

  function destroySlider() {
    document.querySelectorAll(".trust-badge-bar__inner.mobile-slider").forEach(slider => {
      if (slider.dataset.intervalId) {
        clearInterval(slider.dataset.intervalId);
      }
      slider.dataset.sliderInit = "";
    });
  }

  initSlider();

  window.addEventListener("resize", function () {
    destroySlider();
    initSlider();
  });

});